import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module13Nav = () => {
  const { module13 } = useSelector((state) => state.module13, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module13Images/Unit3Mod3_JourneyMap.png';
    const mobileImage =
      '/Module13Images/Unit3Mod3_JourneyMap_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module8Images/Module8NavImages/Background_JourneyMap_Unit2_Mod3.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module8Images/Module8NavImages/JourneyMap_Mod3_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module8Images/Module8NavImages/JourneyMap_Mod3_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/changefeelings',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/change_feelings/change_feelings_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/ask_affirmation.mp4`,
      `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/ask_video_message.mp4`,
      `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/answer_video_message.mp4`,
      `influencers/${login.influencerid3}/ask_affirmation.mp4`,
      `userfiles/${module13.StudentID}/change_feelings_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/ask_affirmation.mp4`
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE13'
          module={module13}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit3'
          nextDestiny='/unit3'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={3}
          animal={MediaService.getImage('/Images/Button_Lizardhead.png', login)}
        />
      )}
    </>
  );
};
export default Module13Nav;
